module.exports = __webpack_public_path__ + "static/media/ano-banner.c48d709f.png";